import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import LoadingScreen from '../components/common/LoadingScreen/LoadingScreen';
import { config } from '../config/environment';

const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
});

console.log('config', config);
console.log('baseUrl', config.apiBaseUrl);

let loadingCount = 0;
const loadingRoot = document.createElement('div');
document.body.appendChild(loadingRoot);

const showLoading = () => {
  loadingCount++;
  if (loadingCount === 1) {
    ReactDOM.render(React.createElement(LoadingScreen), loadingRoot);
  }
};

const hideLoading = () => {
  loadingCount--;
  if (loadingCount === 0) {
    ReactDOM.unmountComponentAtNode(loadingRoot);
  }
};

apiClient.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    if (refreshToken) {
      config.headers['Refresh-Token'] = refreshToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    hideLoading();
    return response;
  },
  async (error) => {
    hideLoading();
    
    if (error.response?.status === 401) {
      const refreshToken = localStorage.getItem('refreshToken');
      const originalRequest = error.config;
      
      if (!originalRequest._retry && refreshToken) {
        originalRequest._retry = true;
        
        try {
          const response = await axios.post(`${config.apiBaseUrl}/pxauth/verify_refresh_token/`, {
            refresh_token: refreshToken
          });
          
          const { access_token, refresh_token } = response.data.data;
          
          localStorage.setItem('accessToken', access_token);
          localStorage.setItem('refreshToken', refresh_token);
          
          originalRequest.headers['Authorization'] = `Bearer ${access_token}`;
          originalRequest.headers['Refresh-Token'] = refresh_token;
          
          return apiClient(originalRequest);
        } catch (refreshError) {
          localStorage.clear();
          window.location.href = '/signin';
          return Promise.reject(refreshError);
        }
      }
    }
    
    if (error.response?.status === 403) {
      localStorage.clear();
      window.location.href = '/signin';
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
